import { defineAsyncComponent } from "vue";
import {
  get_headers,
  get_project_id,
  verify_super_user_status,
} from "@/utils/constants/constants.js";
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import "datatables.net";
import "datatables.net-dt/css/dataTables.dataTables.css";
import viewEntityTypeCoreMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_core_mixin";
import viewEntityTypeAdvertsMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_adverts_mixin";
import viewEntityTypeAdvertPageMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_advert_page_mixin";
import viewEntityTypeFormsMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_forms_mixin";
import viewEntityTypeTemplatesMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_templates_mixin";
import viewEntityTypeWorkflowsMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_workflows_mixin";
import viewEntityTypeContractsMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_contracts_mixin";
import viewEntityTypePageMixin from "@/utils/mixins/view_entity_type_mixins/view_entity_type_page_mixin";
import CreateAdvertModal from "@/components/probaworkflows_base_components/CreateAdvertModal/CreateAdvertModal.vue";
import ViewAdvertModal from "@/components/probaworkflows_base_components/ViewAdvertModal/ViewAdvertModal.vue";
import EditAdvertModal from "@/components/probaworkflows_base_components/EditAdvertModal/EditAdvertModal.vue";

const FilePreviewComponent = defineAsyncComponent(() =>
  import("@/components/probaworkflows_base_components/FilePreviewComponent/FilePreviewComponent.vue")
);
const GlobalTable = defineAsyncComponent(() =>
  import("@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue")
);
const InvoiceSteps = defineAsyncComponent(() =>
  import("@/views/probaworkflows_base/invoicing/invoice_steps/InvoiceSteps.vue")
);
const ComplianceRules = defineAsyncComponent(() =>
  import("@/views/probaworkflows_base/management/compliance_management/compliance_rules/ComplianceRules.vue")
);
const AssignedSubEntities = defineAsyncComponent(() =>
  import("@/views/probaworkflows_base/management/entity_management/assigned_sub_entities/AssignedSubEntities.vue")
);
const EntityTypeAttributes = defineAsyncComponent(() =>
  import("@/views/probaworkflows_base/management/entity_management/entity_type_attributes/EntityTypeAttributes.vue")
);
const WidgetManagement = defineAsyncComponent(() =>
  import("@/views/probaworkflows_base/management/entity_management/entity_type_widgets/WidgetManagement.vue")
);
const CreateForms = defineAsyncComponent(() =>
  import("@/views/probaworkflows_base/management/survey_managment/create_forms/CreateForms.vue")
);
const ManageApprovalRules = defineAsyncComponent(() =>
  import("../approval_rules_management/manage_approval_rules/ManageApprovalRules.vue")
);

export default {
  name: "ViewEntityType",
  mixins: [
    alert_mixin,
    formatting_mixins,
    viewEntityTypeCoreMixin,
    viewEntityTypeAdvertsMixin,
    viewEntityTypeAdvertPageMixin,
    viewEntityTypeFormsMixin,
    viewEntityTypeTemplatesMixin,
    viewEntityTypeWorkflowsMixin,
    viewEntityTypeContractsMixin,
    viewEntityTypePageMixin,
  ],
  components: {
    CreateAdvertModal,
    ViewAdvertModal,
    EditAdvertModal,
    GlobalTable,
    ManageApprovalRules,
    CreateForms,
    InvoiceSteps,
    ComplianceRules,
    AssignedSubEntities,
    FilePreviewComponent,
    EntityTypeAttributes,
    WidgetManagement,
  },
  data: () => ({
    job_adverts: [],
    advert_applicant_counts: {
      byId: Object.create(null),
      byTitle: Object.create(null),
      byReference: Object.create(null),
    },
    advert_count_hydrated_entity_type_ids: [],
    loading_job_adverts: false,
    selectedJobId: sessionStorage.getItem("selected_job_profile_id") || sessionStorage.getItem("entity_type_id") || null,
    headers: get_headers(),
    project_id: get_project_id(),
    entity_type_id: sessionStorage.getItem("entity_type_id"),
    entity_type_name: sessionStorage.getItem("entity_type_name"),
    selected_form_id: "",
    active_tab: "Job Adverts",
    tabs: ["Job Adverts", "Job Forms", "Templates"],
    is_super_user: false,
    email: "",
    form_list: [],
    form_table_headers: [],
    assigned_templates: [],
    loading_templates: false,
    table_safe_form_list: [],
    manage_template: [],
    manage_approval_rules: [],
    manage_invoice_steps: [],
    manage_compliance: [],
    document_url: null,
    form_name: "",
    form_description: "",
    dataTable: null,
    selected_template: {},
    selected_file: "",
    upload_loading: false,
    show_upload_modal: false,
    new_template_name: "",
    upload_from_entity_page: false,
    upload_entity_type_id: null,
    preview_modal: false,
    template_document_entity_type_id: null,
    workflows: [],
    workflows_table_headers: [],
    assigned_workflow: [],
    create_advert_data: {
      title: "",
      reference_number: "",
      opening_date: "",
      closing_date: "",
      vacancies: null,
      details: "",
      sections: [],
      display_order: [],
    },
    advert_profile: null,
    advert_loading_profile: false,
    advert_saving: false,
    view_advert_data: {},
    edit_advert_data: {
      id: null,
      title: "",
      reference_number: "",
      published_date: "",
      closing_date: "",
      vacancies: null,
      details: "",
      sections: [],
    },
    expanded_templates: [],
    selected_row: {
      id: Number(sessionStorage.getItem("entity_type_id")) || null,
      entity_type: sessionStorage.getItem("entity_type_name") || "",
    },
    selected_advert: null,
    create_advert_open_nonce: 0,
    view_advert_open_nonce: 0,
    edit_advert_open_nonce: 0,
    advert_search: "",
    advert_page: 1,
    advert_page_size: 10,
    advert_status_filter: "all",
    select_template_id: null,
    modal_template: { id: null, name: "", template_name: "" },
    table_safe_contracts: [],
    contracts_by_template: {},
    loading: false,
  }),
  computed: {
    filtered_data() {
      switch (this.active_tab) {
        case "Forms":
          return this.form_list;
        case "Template":
          return this.manage_template;
        case "Invoice Steps":
          return this.manage_invoice_steps;
        case "Compliance":
          return this.manage_compliance;
        default:
          return [];
      }
    },
    advert_visible_sections() {
      if (!this.advert_profile?.sections) return [];
      return this.advert_profile.sections.filter(s => s.show_on_advert !== false);
    },
  },
  async mounted() {
    this.headers = get_headers();
    await this.check_super_user();
    if (this.$route.query.all_adverts === "true") {
      this.active_tab = "Job Adverts";
      localStorage.setItem("active_tab", "Job Adverts");
      await this.get_job_adverts();
      return;
    }
    this.sync_active_tab_from_storage();
    if (this.should_auto_assign_template()) {
      await this.load_auto_assign_template_state();
      return;
    }
    await this.load_active_tab_data();
  },
  methods: {
    async check_super_user() {
      this.is_super_user = await verify_super_user_status();
      if (!this.is_super_user) {
        const super_user_tabs = [
          "Job Forms",
          "Templates",
          "Invoice Steps",
          "Compliance",
          "Sub-Entities",
          "Approval Rules",
        ];
        this.tabs = this.tabs.filter(tab => !super_user_tabs.includes(tab));
      }
    },
  },
};
